// AstriaUKV2ThemeContext.tsx
import React, { createContext, useContext } from "react";
import { useUKV2Theme, UKV2Palette } from "./astriaUKV2Theme";

// Single source of truth for the UK lane's light/dark toggle — the shell
// owns the toggle button, every tab/card reads the resolved palette from
// here so the whole dashboard switches together instead of each component
// tracking (and possibly disagreeing on) theme state independently.

interface UKV2ThemeContextValue {
  theme: "light" | "dark";
  colors: UKV2Palette;
  toggleTheme: () => void;
}

const UKV2ThemeContext = createContext<UKV2ThemeContextValue | undefined>(undefined);

export const AstriaUKV2ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useUKV2Theme();
  return <UKV2ThemeContext.Provider value={value}>{children}</UKV2ThemeContext.Provider>;
};

export function useUKV2Colors(): UKV2ThemeContextValue {
  const ctx = useContext(UKV2ThemeContext);
  if (!ctx) {
    throw new Error("useUKV2Colors must be used within an AstriaUKV2ThemeProvider");
  }
  return ctx;
}
